/*****************************************************************************************
 * エントリーポイントファイル
 *
 * 新規のエントリーポイントの追加時にはwebpackの再起動が必要になるので注意
 ****************************************************************************************/

/** imports */
import * as React from 'react';
import { createRoot } from 'react-dom/client';
// our components
import { Main } from './main'
// import { SnackbarProviderComponent } from '../../../components/snackbarProviderComponent'

/** DOMへのrender */
// <div id='projects_show'/> のコンポーネントが必要なことに注意
const rootElement = document.getElementById('projects_show');

if (rootElement) {
  const root = createRoot(rootElement)
  root.render(
    // <SnackbarProviderComponent>
      <Main />
    // </SnackbarProviderComponent>
  )
}